<template >
  <div id="competingProducts" class="page-wrap">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>竞品数据对比</el-breadcrumb-item>
      <el-breadcrumb-item>竞品对比-数据分析</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <el-row class="executionPage">
        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            {{ $store.state.globalLowPrice }}汇总对比
          </div>
          <div class="fontDiv2" style="height:600px;">
						<el-select v-model="platform1" placeholder="平台" @change="selectChange(1)">
							<el-option
								v-for="item in platFromList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-select v-model="dateType1" placeholder="时间" style="margin-left: 20px;" @change="selectChange(1)">
							<el-option
								v-for="item in dateList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-select v-model="shopid1" multiple filterable collapse-tags placeholder="店铺" style="margin-left: 20px;" @change="shopChange(1)" v-loading="spLoading1" element-loading-spinner="el-icon-loading">
							<el-option
								v-for="item in shopList"
								:key="item.id"
								:label="item.shopName"
								:value="item.id">
							</el-option>
						</el-select>
						<el-select v-model="dealerid1" multiple filterable collapse-tags placeholder="经销商" style="margin-left: 20px;" @change="classifyChange(1)">
							<el-option
								v-for="item in BmcList"
								:key="item.id"
								:label="item.dealername"
								:value="item.id">
							</el-option>
						</el-select>
						<el-cascader
							filterable
							clearable
							placeholder="产品"
							v-model="productid1"
							:options="options"
							:props="productidChildren"
              collapse-tags
							@change="handleChange1"
							style="margin-left: 20px;width: 500px;">
						</el-cascader>
            <el-col :span="24" style="margin-top: 30px;">
              <div id="planEchartsId" style="width: 90%;height: 500px;"> </div>
            </el-col>
          </div>
        </el-col>

        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            低价趋势对比
          </div>
          <div class="fontDiv2">
						<el-select v-model="platform2" placeholder="平台" @change="selectChange(2)">
							<el-option
								v-for="item in platFromList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-select v-model="dateType2" placeholder="时间" style="margin-left: 20px;" @change="selectChange(2)">
							<el-option
								v-for="item in dateList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-select v-model="shopid2" multiple filterable collapse-tags placeholder="店铺" style="margin-left: 20px;" @change="shopChange(2)" v-loading="spLoading2" element-loading-spinner="el-icon-loading">
							<el-option
								v-for="item in shopList2"
								:key="item.id"
								:label="item.shopName"
								:value="item.id">
							</el-option>
						</el-select>
						<el-select v-model="dealerid2" multiple filterable collapse-tags placeholder="经销商" style="margin-left: 20px;" @change="classifyChange(2)">
							<el-option
								v-for="item in BmcList"
								:key="item.id"
								:label="item.dealername"
								:value="item.id">
							</el-option>
						</el-select>
						<el-cascader
							filterable
							clearable
							placeholder="产品"
							v-model="productid2"
							:options="options"
							:props="productidChildren"
              collapse-tags
							@change="handleChange2"
							style="margin-left: 20px;width: 500px;">
						</el-cascader>
            <el-col :span="24" style="margin-top: 30px;">
              <div id="monitorLinklistEcharts" style="width: 90%;height: 400px;"></div>
            </el-col>
          </div>
        </el-col>

        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            低价汇总排名
          </div>
          <div class="fontDiv3">
						<el-select v-model="platform3" placeholder="平台" @change="selectChange(3)">
							<el-option
								v-for="item in platFromList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-select v-model="dateType3" placeholder="时间" style="margin-left: 20px;" @change="selectChange(3)">
							<el-option
								v-for="item in dateList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-select v-model="type" placeholder="类型" style="margin-left: 20px;" @change="shopChange(3)">
							<el-option
								v-for="item in typeData"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-table
				      :data="tableData"
							v-loading="actLoading"
				      element-loading-text="拼命加载中"
				      element-loading-spinner="el-icon-loading"
              height="530px"
				      style="width: 100%;margin-top: 20px;">
              <el-table-column label="排名" width="120">
                <template slot-scope="scope">
                  <span :class='scope.$index<3?"right_num":""'>{{ ++scope.$index }}</span>
                </template>
              </el-table-column>
				      <el-table-column
				        prop="name"
				        label="品牌">
				      </el-table-column>
				      <el-table-column
				        prop="linknum"
				        label="链接数量">
				      </el-table-column>
							<el-table-column
				        prop="lowpricenum"
				        label="低价数量">
				      </el-table-column>
							<el-table-column
				        prop="lowpriceprobability"
				        label="低价率">
				      </el-table-column>
				    </el-table>
          </div>
        </el-col>

        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            链接价格趋势对比
          </div>
          <div class="fontDiv4">
						<el-select v-model="platform4" placeholder="平台">
							<el-option
								v-for="item in platFromList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-select v-model="dateType4" placeholder="时间" style="margin-left: 20px;">
							<el-option
								v-for="item in dateList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
            <el-select v-model="priceType" placeholder="价格" style="margin-left: 20px;">
							<el-option
								v-for="item in priceList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
            <el-cascader
              filterable
              clearable
              placeholder="产品"
              v-model="productid4"
              :options="options"
              :props="productidChildren"
              collapse-tags
              @change="handleChange4"
              style="margin-left: 20px;width: 500px;">
            </el-cascader>
            <el-button type="primary" style="margin-left: 20px;" @click="getIprPluginListList">选择链接</el-button>
            <el-dialog title="选择链接" :visible.sync="dialogTableVisible">
              <!--表格-->
              <el-table ref="multipleTable" height="600px" :data="tableList" tooltip-effect="dark" style="width: 100%;height: 600px;" @selection-change="selectionChange" v-loading="dataLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" :row-key="getRowKeys">
                <el-table-column type="selection" width="50" fixed="left" :selectable="handleDisable" :reserve-selection="true"></el-table-column>
                <el-table-column label="商品信息" prop="itemtitle">
                  <template slot-scope="scope" class="shopInfo">
                    <div class="shopMain">
                      <el-image :src="scope.row.logopicurl_details?scope.row.logopicurl_details:scope.row.logopicurl" style="height: 84px;width: 84px;margin-right: 12px;"></el-image>
                      <div class="content">
                        <el-link class="align_left two_ellipsis" :underline="false" :href="scope.row.itemlink" type="primary" target="_blank">
                          {{scope.row.itemtitle_details?scope.row.itemtitle_details:scope.row.itemtitle}}
                        </el-link>
                        <div class="align_left" v-show="scope.row.itemtype != 2">
                          {{scope.row.productname}}
                          <el-popover placement="top-start" width="200" trigger="hover" v-show="scope.row.productname">
                            <div>
                              <div v-for="item in  $options.filters.objToAr(scope.row.productPrice)" :key="item.name">
                                <div>{{item.name}}:{{item.val}}</div>
                              </div>
                            </div>
                            <i class="el-icon-warning-outline" slot="reference"></i>
                          </el-popover>
                        </div>
                        <el-button type="primary" size="mini" plain @click="skuListChildShow(scope.row)" v-show="scope.row.itemtype == 2">
                          SKU列表
                        </el-button>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <pagination
                v-if="tableList&&tableList.length>0"
                :currentPage="pageNo" :pageSizes="[10, 20, 30, 40]"
                :total="total" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
              </pagination>

              <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="getStackedLineByLinkList" size="mini">确 定</el-button>
                <el-button @click="dialogTableVisible = false" size="mini">取 消</el-button>
              </span>
            </el-dialog>
            <el-col :span="24" style="margin-top: 30px;">
              <div id="stackedLineByLinkListEcharts" style="width: 90%;height: 500px;"></div>
            </el-col>
          </div>

        </el-col>

      </el-row>
    </div>
    <skuList ref="skuListChild" :dictCodeShow="dictCodeShow" :skuType="skuType" @childChange="childData" :skuids="skuids"></skuList>
  </div>
</template>

<script>
  import echarts from 'echarts'
  import skuList from "../Brand/BrandMerchandise/skuList"; //sku列表
  import aes from "@/libs/aes";
  import pagination from "../../components/dataTable/pagination";
  export default {
    data(){
      return{
        shopList: [],
				shopList2: [],
				BmcList: [],
				options: [],
				productidChildren: {
          value: "id",
          label: "productClassifyName",
          children: "children",
          multiple: true
        },
				platFromList: [{
					label: '全部',
					value: '',
				},{
					label: "淘宝",
					value: "TB",
				},{
					label: "天猫",
					value: "TM",
				},{
					label: "1688",
					value: "1688",
				},{
					label: "京东",
					value: "JD",
				},{
					label: "拼多多",
					value: "PDD",
				},{
					label: "苏宁易购",
					value: "SN",
				},{
					label: "当当网",
					value: "DD",
				}],
				dateList: [{
					label: "7天",
					value: "7",
				},{
					label: "15天",
					value: "15",
				},{
					label: "30天",
					value: "30",
				},{
					label: "年",
					value: "year",
				}],

				platform1: "",
				dateType1: "7",
				shopid1: [],
				dealerid1: [],
				productid1: [],

				platform2: "",
				dateType2: "7",
				shopid2: [],
				dealerid2: [],
				productid2: [],

				platform3: "",
				dateType3: "7",
				type: "",
				tableData: [],
        typeData: [{
					label: "店铺排名",
					value: "2",
				},{
					label: "经销商排名",
					value: "1",
				},{
					label: "产品排名",
					value: "3",
				}],
				actLoading: false,
        priceType: "1",
        priceList: [{
					label: "商品标价",
					value: "1",
				},{
					label: "商品到手价",
					value: "2",
				}],

        pageNo: 1,
        pageSize: 10,
        productid4: [],
        platform4: "",
				dateType4: "7",
        skuids: "",
        tableList: [],
        total: 10,
        currentPage: 1,
        dataLoading: false,

        dictCodeShow: false,
        skuType: 0,
        dialogTableVisible: false,
        hcmCheckLinkList: [],
        errList: [],

        spLoading1: false,
        spLoading2: false,
      }
    },
    mounted() {
      this.GetList(1)
      this.GetList(2)
			this.getlistOfBmc()
			this.getListBybmcid()
			this.getCompetitiveList()
      this.getStackedLineList()
			this.getRankingList()
      let xAxis,series
      this.planEcharts(xAxis,series)
      this.adminMonitorLinklistEcharts(xAxis,series)
      this.adminStackedLineByLinkListEcharts(xAxis,series)
    },
    components: {
  		skuList,
      pagination
    },
    filters: {
      objToAr: aes.objToArr
    },
    methods:{
			// 获取店铺
			GetList(e) {
				let params={
					shopname: '',
				}
        if (e === 1) {
          this.spLoading1 = true
          params.platform = this.platform1
        } else {
          this.spLoading2 = true
          params.platform = this.platform2
        }
				fetch({
					url: "/hcm/hcmShop/findShopByName",
					method: "get",
					params: params,
					noFormat: true,
					responseType: "text"
				}).then(result => {
					let res = JSON.parse(result);
					let {data}=res
					if(res.status == '10000'){
            if (e === 1) {
              this.shopList = res.data
              this.spLoading1 = false
            } else {
              this.shopList2 = res.data
              this.spLoading2 = false
            }
					}
				})
			},
			// 获取经销商
			getlistOfBmc() {
				fetch({
					url: "/hcm/dealer/getlistOfBmc",
					method: "get",
					noFormat: true,
					responseType: "text"
				}).then(result => {
					let res = JSON.parse(result);
					let {data}=res
					if(res.status == '10000'){
						this.BmcList = res.data
					}
				})
			},
			// 获取产品
      getListBybmcid() {
        fetch({
          url: "hcm/hcmProduct/getListBybmcid",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            this.options = result.data;
          }
        });
      },
      // 平台、日期搜索
      selectChange(e) {
        if (e == 1) {
          this.shopid1 = []
          this.GetList(1)
					this.getCompetitiveList()
				} else if (e == 2) {
          this.shopid2 = []
          this.GetList(2)
					this.getStackedLineList()
				} else if (e == 3) {
					this.getRankingList()
				} else {
          this.getStackedLineByLinkList()
        }
      },
			// 低价汇总对比选择店铺
			shopChange(e) {
				if (e == 1) {
					this.dealerid1 = []
					this.productid1 = [];
					this.getCompetitiveList()
				} else if (e == 2) {
					this.dealerid2 = []
					this.productid2 = [];
					this.getStackedLineList()
				} else if (e == 3) {
					this.getRankingList()
				}
			},
			// 低价汇总对比选择经销商
			classifyChange(e) {
				if (e == 1) {
					this.shopid1 = []
					this.productid1 = [];
					this.getCompetitiveList()
				} else if (e == 2) {
					this.shopid2 = []
					this.productid2 = [];
					this.getStackedLineList()
				}
			},
			// 低价汇总对比选择产品
			handleChange1(value) {
				this.dealerid1 = []
				this.shopid1 = []
        this.productid1 = value;
				this.getCompetitiveList()
      },
			// 低价汇总对比echarts
			getCompetitiveList() {
				let params = {
					platform: this.platform1,
					dateType: this.dateType1
				}
				if (this.shopid1.length != 0) {
					params.shopid = this.shopid1.join(',')
				}
				if (this.dealerid1.length != 0) {
					params.dealerid = this.dealerid1.join(',')
				}
				if (this.productid1.length != 0) {
          let pId = []
          for (let b in this.productid1) {
            pId.push(this.productid1[b][1].split(',')[0])
          }
					params.productid = pId.join(',')
				}
				fetch({
          url: "hcm/iprNewPluginList/getCompetitiveList",
          method: "get",
          noFormat: true,
					params: params,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
						let series
						let xAxis
						if (res.data.series) {
							series = res.data.series
						}
						if (res.data.xAxis) {
							xAxis = res.data.xAxis
						}
            this.planEcharts(series,xAxis)
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
			},
			// 低价汇总对比Echarts
      planEcharts(series,xAxis) {
        this.chartLine2 = echarts.init(document.getElementById('planEchartsId'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
					toolbox: {
				    feature: {
				      saveAsImage: {}
				    }
				  },
          color: ['#1890ff'],
          grid: {
            left:"1%", //距离左边的边距
            top: "5%", //距离上部的边距
            // bottom: 100,
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: xAxis,
            axisLabel : {//坐标轴刻度标签的相关设置。
             interval:0,
             rotate:"45"
            }
          },
          yAxis: {
            type: 'value',
          },
          series: [
						{
				      data: series,
				      type: 'bar',
				      showBackground: true,
				      backgroundStyle: {
				        color: 'rgba(180, 180, 180, 0.2)'
				      }
				    }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine2.setOption(option,true);
      },
			// 低价汇总对比选择产品
			handleChange2(value) {
				this.dealerid2 = []
				this.shopid2 = []
        this.productid2 = value;
				this.getStackedLineList()
      },
      // 链接价格趋势对比
      handleChange4(value) {
        this.productid4 = value;
      },
      // 低价趋势对比
      getStackedLineList() {
				let params = {
					platform: this.platform2,
					dateType: this.dateType2
				}
				if (this.shopid2.length != 0) {
					params.shopid = this.shopid2.join(',')
				}
				if (this.dealerid2.length != 0) {
					params.dealerid = this.dealerid2.join(',')
				}
        if (this.productid2.length != 0) {
          let pId = []
          for (let b in this.productid2) {
            pId.push(this.productid2[b][1].split(',')[0])
          }
					params.productid = pId.join(',')
				}
        fetch({
          url: "hcm/iprNewPluginList/getStackedLineList",
          method: "get",
          noFormat: true,
					params: params,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
						let xAxis
						let series
						if (res.data.xAxis) {
							xAxis = res.data.xAxis
						}
						if (res.data.series) {
							series = res.data.series
						}
						this.adminMonitorLinklistEcharts(xAxis,series)
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 监控链接今日实际监控链接数Echarts
      adminMonitorLinklistEcharts(xAxis,series) {
        this.chartLine3 = echarts.init(document.getElementById('monitorLinklistEcharts'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
					toolbox: {
				    feature: {
				      saveAsImage: {}
				    }
				  },
          color: ['#1890ff','#2fc25b','#facc14','#223273','#8543e0','#13c2c2'],
          grid: {
            left:"1%", //距离左边的边距
            top: "5%", //距离上部的边距
          },
          xAxis: {
            type: 'category',
            data: xAxis,
          },
          yAxis: {
            type: 'value'
          },
          series: series
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine3.setOption(option,true);
      },
			getRankingList() {
				let params = {
					platform: this.platform3,
					dateType: this.dateType3
				}
				if (this.type) {
					params.type = this.type
				}
				this.actLoading = true
        fetch({
          url: "hcm/iprNewPluginList/getRankingList",
          method: "get",
          noFormat: true,
					params: params,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
						this.tableData = res.data
						this.actLoading = false
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
			},
      // 禁用
      handleDisable(row,index) {
        if (row.itemtype == 2) {
          return false
        }else{
          return true
        }
      },
      // 时间处理
      getPreviousDate(numOfDays) {
        var date = new Date();
        date.setDate(date.getDate() - numOfDays);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        return year + "-" + month + "-" + day;
      },
      handleSizeChange(val) {
        //每页
        this.pageSize = val;
        this.getIprPluginListList();
      },
      handleCurrentChange(val) {
        //当前页
        this.pageNo = val;
        this.getIprPluginListList();
      },
      // 商品库链接
      getIprPluginListList() {
        this.skuids = ""
        // this.hcmCheckLinkList = []
        console.log('fanye',this.hcmCheckLinkList)
        this.dialogTableVisible = true
        let that = this;
        let newProductid = [];
        let datas = {
          pageNo: that.pageNo,
          pageSize: that.pageSize,
          platform: that.platform4
        };
        if (this.productid4.length != 0) {
          let pId = []
          for (let b in this.productid4) {
            pId.push(this.productid4[b][1].split(',')[0])
          }
					datas.productid = pId.join(',')
				}
        if (this.dateType4) {
          datas.starttime = this.getPreviousDate(this.dateType4)
          datas.endtime = this.getPreviousDate(0)
        }
        this.dataLoading = true
        fetch({
          url: "hcm/iprNewPluginList/getIprNewPluginListList",
          method: "post",
          data: datas,
          timeout: 60 * 1000 * 5
        })
        .then(res => {
          let data = res.data;
          if (res.status == "10000") {
            that.tableList = [];
            this.tableList = data.content;
            that.total = data.totalElements;
            this.dataLoading = false
          }
        })
        .catch(err => {

        });
      },
      selectionChange(data) {
        console.log(data)
        this.errList = []
        if (data.length > 30) {
          this.$message({
            message: '商品信息最多只能选择30条',
            type: 'warning'
          });
          return
        }
        for (let a in data) {
          this.errList.push({
            itemid: data[a].itemid,
            skuid: "",
            name: data[a].itemtitle +
            (data[a].price && this.priceType == 1 ? "_标价" + data[a].price : '') +
            (data[a].availableprice && this.priceType == 2 ? "_到手价" + data[a].availableprice : '') +
            (data[a].discountchange ? "_优惠券" + data[a].discountchange : '')
          })
        }
      },
      // 链接价格趋势对比数据
      getStackedLineByLinkList() {
        console.log(this.errList.length,"this.errList")
        if (this.errList.length != 0) {
          for (let cc in this.errList) {
            this.hcmCheckLinkList.push(this.errList[cc])
          }
        }
        let arr = []
        for (let abc in this.hcmCheckLinkList) {
          if (this.hcmCheckLinkList[abc].itemid !== '删除') {
            arr.push(this.hcmCheckLinkList[abc])
          }
        }
        console.log(arr.length,"hcmCheckLinkList---arr")
        if (arr.length > 30) {
          this.$message({
            message: '商品信息最多只能选择30条',
            type: 'warning'
          });
          return
        }

				let params = {
          dateType: this.dateType4,
					hcmCheckLinkList: arr
				}
        if (this.priceType) {
          params.priceType = this.priceType
        }

        fetch({
          method: 'POST',
  				url: 'hcm/iprNewPluginList/getStackedLineByLinkList',
  				data: JSON.stringify(params),
  				headers: {
  					'Content-Type': 'application/json'
  				}
        }).then(res => {
          if(res.status == '10000'){
            this.dialogTableVisible = false
            let xAxis
            let series
            if (res.data.xAxis) {
							xAxis = res.data.xAxis
						}
						if (res.data.series) {
							series = res.data.series
						}
            this.hcmCheckLinkList = []
            this.$refs.multipleTable.clearSelection();
            this.adminStackedLineByLinkListEcharts(xAxis,series)
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
			},
      // 链接价格趋势对比Echarts
      adminStackedLineByLinkListEcharts(xAxis,series) {
        let name = []
        for (let a in series) {
          name.push(series[a].name)
        }
        this.chartLine4 = echarts.init(document.getElementById('stackedLineByLinkListEcharts'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            y: 'bottom',
            data: name,
            formatter(name) {
              // 超过指定字符省略显示
              return name.length > 30 ? `${name.substr(0, 30)}...` : name;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: 200,
            containLabel: true
          },
					toolbox: {
				    feature: {
				      saveAsImage: {}
				    }
				  },
          xAxis: {
            type: 'category',
            data: xAxis,
          },
          yAxis: {
            type: 'value'
          },
          series: series
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine4.setOption(option,true);
      },
      //显示sku弹窗
      skuListChildShow(row) {
        let that = this;
        this.skuData = {
          itemid: row.itemid,
          platform: row.platform,
          pageNo: 1,
          pageSize: 10000,
          itemtitle: row.itemtitle,
          price: row.price,
          availableprice: row.availableprice,
          discountchange: row.discountchange,
          priceType: this.priceType,
        };
        //显示sku弹窗
        this.$refs.skuListChild.dialogVisibleShow(row.itemid);
        this.$refs.skuListChild.getSkuList(this.skuData);
        this.$refs.skuListChild.getSkuData(this.skuids);
      },
      // 父传子
      childData(data) {
        // 先在总数组数据里面去寻找是否有这个itemid的数据，有的话先清除
        if (this.hcmCheckLinkList.length != 0) {
          for (let a in this.hcmCheckLinkList) {
            if (this.hcmCheckLinkList[a].itemid == data.itemid) {
              this.hcmCheckLinkList[a].itemid = "删除"
            }
          }
        }
        // 然后再把数据录入进去
        for (let a in data.sku) {
          this.hcmCheckLinkList.push(data.sku[a])
        }
        // // 数据去重
        // this.hcmCheckLinkList = this.deWeightThree()
        let nId = []
        for (let a in data.sku) {
          nId.push(data.sku[a].skuid)
        }
        this.skuids = nId.join(',')
      },
      getRowKeys(row) {
        // id 是后台传递的每行信息唯一标识
        return row.id;
      },

      // // 数组对象去重
      // deWeightThree() {
      //   let name = 'name';
      //   let map = new Map();
      //   for (let item of this.hcmCheckLinkList) {
      //       if (!map.has(item.name)) {
      //           map.set(item.name, item);
      //       }
      //   }
      //   return [...map.values()];
      // },
    }
  }
</script>

<style lang="scss">
  @import "src/style/outReview";
  #competingProducts{
    .executionPage {
			.el-table th {
		    background-color: #f3f7ff !important;
		  }
      margin: 20px;
      .iconDiv {
        width: 5px;
        background-color: #333333;
        margin-right: 10px;
        height: 21px;
        margin-top: 4px;
      }
      .fontDiv2 {
        padding: 20px;
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        height: 460px;
        margin-bottom: 20px;
      }
			.fontDiv3 {
        padding: 20px;
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        height: auto;
        margin-bottom: 20px;
      }
      .fontDiv4 {
        padding: 20px;
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        height: 560px;
        margin-bottom: 20px;
      }
    }
  }
</style>
